import { render } from "./home_old.vue?vue&type=template&id=bd0117a2&scoped=true"
import script from "./home_old.vue?vue&type=script&lang=js"
export * from "./home_old.vue?vue&type=script&lang=js"

import "./home_old.vue?vue&type=style&index=0&id=bd0117a2&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0117a2"]])

export default __exports__